import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const SubstituicaoFeriasService = {
  async getSubstituicao(id_ferias) {

    const response = await BaseService.fetchResponseFromAPIGet(`substituicao/${id_ferias}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },

  async pegarQuemMilitarEstaSubstituindo(idSigrh) {

    const response = await BaseService.fetchResponseFromAPIGet(`substituicoes/${idSigrh}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
   
    return response.content;
  },
  async getSubstituicaoById(id) {

    const response = await BaseService.fetchResponseFromAPIGet(`substituicoes/${id}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },

  async pegarMilitarPeloNumeroBM  (postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `militar/numerobm`,
      postData
    );
    if (response.error) {
      SnackBarModule(response.message.response, "error");
    }
    return response.message;
  },

  async criarSubstituicaoFerias(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `substituicao`,
      postData
    );
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }
    SnackBarModule(await response.message, "success");
    return true;
  },

}